import images from '@/functions/images'
import lang from '@/language/de'
import idb from '@/functions/idb'
import moment from 'moment'

export default class Protocol {
  constructor () {
    this.api_id = undefined
    this.signature_owner = ''
    this.signature_tenant = ''
    this.signature_old_tenant = ''
    this.signature_inspector = ''
    this.email_owner = ''
    this.email_old_tenant = ''
    this.email_tenant = ''
    this.email_inspector = ''
    this.cause = {
      preliminary: false,
      final: false,
      state: false,
      transmission: false
    }
    this.floor = ''
    this.location = {
      left: '',
      right: '',
      middle: '',
      behind: '',
      hallway: '',
      vhs: '',
      hhs: ''
    }
    this.structure = {
      room: '',
      bathroom: '',
      restroom: '',
      kitchen: '',
      hallway: '',
      balcony: '',
      terrace: '',
      pantry: '',
      basement: '',
      basement_number: '',
      basement_number_number: '',
      attic: '',
      attic_number: '',
      garden: ''
    }
    this.furniture = {
      heating: {
        district: false,
        gas: false,
        central: false,
        other: false,
        other_value: ''
      },
      tv: {
        antenna: false,
        cable: false,
        satellite: false
      },
      other: {
        bicycle_storage: false,
        lift: false,
        intercom: false,
        shared_washing_machine: false,
        floor: false
      }
    }
    this.meters_data = {
      electricity_1: '',
      electricity_1_data: '',
      electricity_2: '',
      electricity_2_data: '',
      gas: '',
      gas_data: '',
      hot_water_1: '',
      cold_water_1: '',
      hot_water_2: '',
      cold_water_2: '',
      heat: '',
      intermediate_counter: ''
    }
    this.rooms = [
      {
        id: 0,
        name: lang.protocol.rooms.kitchen,
        access: false,
        ceiling: '',
        walls: '',
        window: '',
        doors: '',
        radiator: '',
        radiator_value: '',
        plinth: '',
        floor: '',
        flooring: '',
        tenants_property: false,
        notes: false,
        notes_text: '',
        boiler_gas: false,
        boiler_flowing: false,
        boiler_electric: false,
        exist_boiler_other: false,
        boiler_other: '',
        equipment: '',
        material: '',
        tile: '',
        other: '',
        images: []
      },
      {
        id: 1,
        name: lang.protocol.rooms.bathroom,
        access: false,
        bathroom_set: false,
        ceiling: '',
        walls: '',
        window: '',
        doors: '',
        radiator: '',
        radiator_value: '',
        plinth: '',
        floor: '',
        bath: '',
        bath_structure: {
          freistehende: false,
          einbau: false,
          dusch: false,
          wc: false,
          bidet: false,
          spiegel: false
        },
        washbasin_structure: {
          waschbecken: false,
          ablage: false,
          handtuchhalter: false,
          papierhalter: false,
          duschkabine: false,
          wannenaufsatz: false
        },
        washbasin: '',
        material: '',
        wall_tile: '',
        wall_tile_structure: {
          wandfliesen: false,
          raumhoch: false,
          halbhoch: false,
          turhoch: false
        },
        tile: '',
        notes: false,
        notes_text: '',
        images: []
      },
      {
        id: 2,
        name: lang.protocol.rooms.hall,
        access: false,
        ceiling: '',
        walls: '',
        window: '',
        doors: '',
        radiator: '',
        radiator_value: '',
        plinth: '',
        floor: '',
        tenants_property: false,
        notes: false,
        notes_text: '',
        images: []
      }
    ]
    this.object = ''
    this.basement_description = false
    this.basement_description_text = ''
    this.balcony_description = false
    this.balcony_description_text = ''
    this.tenant = ''
    this.remarks = ''
    this.maintenance_boiler_done = false
    this.maintenance_boiler_not_done = false
    this.maintenance_boiler_date = ''
    this.maintenance_boiler_executor_owner = false
    this.warmly_pays = true
    this.tenant_eliminate_defects = false
    this.tenant_eliminate_defects_method = ''
    this.tenant_warned_of_deadline = false
    this.repairs_delegates_the_execution = false
    this.repairs_deadline = ''
    this.tenant_refuses_to_eliminate = false
    this.strange_text = false
    this.tenant_refuses_to_eliminate_reason = ''
    this.tenant_eliminate_defects_pays = false
    this.tenant_eliminate_defects_pays_sum = ''
    this.barter = false
    this.barter_text = ''
    this.accept = false
    this.accept_amount = ''
    this.condition = lang.protocol.condition_perfect
    this.street = ''
    this.kontoverbindung = ''
    this.new_address = ''
    this.keys = {
      house: '',
      housing: '',
      mailbox: '',
      ground: '',
      vorkeller: '',
      elevator: '',
      garages: '',
      others: ''
    }
    this.notices = ''
    this.date = moment(new Date()).format('YYYY-MM-DD')
    this.repairs_budget = lang.protocol.repairs_budget_tenant
  }

  async createSignature () {
    this.signature_owner = await images.createSignature()
    this.signature_tenant = await images.createSignature()
    this.signature_old_tenant = await images.createSignature()
    this.signature_inspector = await images.createSignature()
    return this
  }

  async saveIdb () {
    let id = await idb.updateProtocol(this)
    this.id = id
  }

  async copy () {
    let newProtocol = new Protocol()
    for (let key in this) {
      if (key !== 'id' && key !== 'api_id' &&
        key !== 'signature_owner' &&
        key !== 'signature_old_tenant' &&
        key !== 'signature_tenant' &&
        key !== 'signature_inspector'
      ) {
        newProtocol[key] = this[key]
      }
    }
    await newProtocol.createSignature()
    newProtocol.id = await idb.updateProtocol(newProtocol)
    return newProtocol
  }

  async init (protocol) {
    for (let key in protocol) {
      this[key] = protocol[key]
    }
    return this
  }

  async delete () {
    await idb.deleteProtocol(this)
  }
}



// WEBPACK FOOTER //
// ./src/classes/protocol.js